import axios from 'axios'

const snakeToCamel = (str) => str.replace(/_([a-z])/g, (_, c) => c.toUpperCase())

const camelToSnake = (str) => str.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`)

const convertKeys = (obj, fn) => {
    if (Array.isArray(obj)) return obj.map((i) => convertKeys(i, fn))

    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(Object.entries(obj).map(([k, v]) => [fn(k), convertKeys(v, fn)]))
    }

    return obj
}

export function installAxiosCasePlugin() {
    // Request → snake_case
    axios.interceptors.request.use((config) => {
        if (config.params) config.params = convertKeys(config.params, camelToSnake)

        if (config.data) config.data = convertKeys(config.data, camelToSnake)

        return config
    })

    // Response → camelCase
    axios.interceptors.response.use((response) => {
        if (response.data) response.data = convertKeys(response.data, snakeToCamel)

        return response
    })
}
